import axios from 'axios'

import { Search } from '@giscube/geoportal'

export default class AdvancedSearch extends Search {
  setICGCSearch (q, layers) {
    const search = this.$config.geocodificadorICGC
    if (search) {
      const config = {
        params: {
          text: q,
          layers: layers,
          ...this.$config.geocodificadorICGC.params
        }
      }
      this.promises.push(new Promise((resolve, reject) => {
        axios.get(search.url, config)
          .then(response => {
            resolve(this.parseICGCResult({ search, data: response.data }))
          })
          .catch(reject)
      }))
    }
  }

  setGeoAPISearch (q, searches, contentType) {
    searches.forEach(search => {
      const config = {
        params: {
          q: q,
          e: contentType
        }
      }
      this.promises.push(new Promise((resolve, reject) => {
        axios.get(search.url, config)
          .then(response => {
            resolve(this.parseResult({ search, data: response.data }))
          })
          .catch(reject)
      }))
    })
  }

  getSearches () {
    let searches = []
    if (this.$context.state.searchOption === 'layer') {
      searches = this.$config.searches.filter(search => search.name === 'geoportal')
    }
    return searches
  }

  setAllSearches (q) {
    if (this.$context.state.searchOption === 'coords') {
      this.setCoordsSearch(q)
    } else if (this.$context.state.searchOption === 'address') {
      const searches = this.$config.searches.filter(search => search.address)
      if (searches.length > 0) {
        this.setGeoAPISearch(q, searches, 'address')
      }
    } else if (this.$context.state.searchOption === 'refcad') {
      const searches = this.$config.searches.filter(search => search.refcad)
      if (searches.length > 0) {
        this.setGeoAPISearch(q, searches, 'refcad')
      }
    } else if (this.$context.state.searchOption === 'addressICGC' && this.$config.geocodificadorICGC) {
      const layers = /\d/.test(q) ? 'address' : 'topo1,topo2'
      this.setICGCSearch(q, layers)
    } else if (this.$context.state.searchOption === 'pk') {
      this.setICGCSearch(q, 'pk')
    } else {
      super.setSearches(q)
    }
  }
}
